export function removeAccents(string){
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
